import { safeTimelineImage, type TimelineScope } from "../lib/delegateTimeline";
import ProtectedImage from "./ProtectedImage";

export default function DelegateTimelineImage({image,scope}: {image:{url:string;alt:string};scope:TimelineScope}) {
  return <ProtectedImage path={safeTimelineImage(image.url,scope)} alt={image.alt || "Captured image"}
    frameClass="delegateProgress__image" buttonClass="delegateProgress__imageButton" />;
}
